import { render, staticRenderFns } from "./TeamNameLogo.vue?vue&type=template&id=28e9fa72&scoped=true"
import script from "./TeamNameLogo.vue?vue&type=script&lang=js"
export * from "./TeamNameLogo.vue?vue&type=script&lang=js"
import style0 from "./TeamNameLogo.vue?vue&type=style&index=0&id=28e9fa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9fa72",
  null
  
)

export default component.exports